export const SET_IS_LOADING_SUCCESS = 'SET_IS_LOADING_SUCCESS'

export const setIsLoading = (isLoading) => dispatch => {
  dispatch({ type: SET_IS_LOADING_SUCCESS, data: { isLoading } })
}






// WEBPACK FOOTER //
// ./src/actions/loading.js